import React from "react";
import "./App.css";

const PaganiZonda = () => {
  return (
    <>
      <head>
        <title>
          Pagani Zonda Price in India | Hypercar Specifications & Review
        </title>

        <meta
          name="description"
          content="Explore Pagani Zonda price in India, engine specifications, top speed and performance details. One of the most expensive hypercars in the world."
        />

        <meta
          name="keywords"
          content="Pagani Zonda price in india, pagani hypercar, most expensive cars in the world, luxury sports car, V12 engine car, branded car price, premium cars"
        />
        <meta name="author" content="CARZOO" />
        <meta name="google-site-verification" content="cc6m8lYZbZqvaqNc19af3idK47cz4WRJbg38JIaQYBU" />

        <meta name="robots" content="index, follow" />

        <meta name="viewport" content="width=device-width, initial-scale=1" />

        <meta property="og:title" content="CARZOO - Premium Car Marketplace" />
        <meta property="og:description" content="Explore luxury cars, compare models and read reviews at CARZOO." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://carzoo.vercel.app/PAGANIZondaa.png" />
        <meta property="og:image" content="https://carzoo.vercel.app/CARZOO-favicon.png" />

        <link rel="canonical" href="https://carzoo.vercel.app/" />

        <link rel="icon" type="image/png" href="/CARZOO-favicon.png" />

        <meta name="theme-color" content="#E35E56" />
      </head>

      <div className="car-details">
        <div className="car-hero">
          <img
            src="./PAGANIZondaa.png"
            alt="Pagani Zonda hypercar"
          />
        </div>

        <div className="car-info">
          <h1>PAGANI Zonda</h1>
          <p className="price">Estimated Price in India: ₹153+ Crore</p>

          <ul>
            <li><strong>Engine:</strong> 7.3L AMG V12</li>
            <li><strong>Power:</strong> 760 HP</li>
            <li><strong>Top Speed:</strong> 355 km/h</li>
            <li><strong>Transmission:</strong> 6-Speed Manual</li>
            <li><strong>Fuel Type:</strong> Petrol</li>
          </ul>

          <p>
            The Pagani Zonda is a legendary hypercar known for extreme
            performance, carbon fiber construction and handcrafted Italian
            engineering. As one of the most exclusive luxury sports cars in the
            world, it represents innovation, speed and artistic automotive
            design.
          </p>
        </div>
      </div>
      <section className="pagani-seo-section">
        <h2>About Pagani Zonda – Iconic Hypercar</h2>

        <p>
          The Pagani Zonda is one of the most expensive cars in the world and a
          benchmark in the hypercar segment. Designed with advanced aerodynamics
          and lightweight carbon fiber materials, this premium car delivers
          outstanding performance and unmatched driving dynamics.
        </p>

        <p>
          Pagani, an Italian luxury car manufacturer, is known for producing
          limited-edition hypercars with exceptional attention to detail. The
          Zonda remains a collector’s dream due to its rare production numbers
          and handcrafted interior finishes.
        </p>

        <h3>Engine & Performance</h3>

        <p>
          Powered by a naturally aspirated 7.3-litre AMG V12 engine, the Pagani
          Zonda produces up to 760 horsepower, making it one of the fastest
          petrol-powered hypercars ever built. With a top speed exceeding
          350 km/h, it offers thrilling acceleration and track-ready performance.
        </p>

        <h3>Pagani Zonda Price in India</h3>

        <p>
          The estimated Pagani Zonda price in India exceeds ₹153 crore,
          depending on customization and import duties. Due to its limited
          production and exclusive nature, it is considered one of the highest
          priced branded cars in the luxury sports car category.
        </p>

        <h3>Why Pagani Zonda Is Special</h3>

        <p>
          Unlike mass-produced sports cars, the Pagani Zonda is built with a
          focus on craftsmanship, performance engineering and exclusivity.
          From its carbon fiber monocoque chassis to its precision-tuned V12
          engine, every element reflects world-class automotive excellence.
        </p>
      </section>
    </>
  );
};

export default PaganiZonda;